import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [TranslateModule, IconComponent],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmModalComponent>);
  private dialogData = inject(MAT_DIALOG_DATA);

  public readonly title = input<string>(
    this.dialogData?.title || 'shop-settings.general.cancelModal.title',
  );
  public readonly desc = input<string>(
    this.dialogData?.desc || 'shop-settings.general.cancelModal.description',
  );

  protected readonly unavailableItems = this.dialogData?.unavailableItems || [];
  protected readonly totalItemsCount: number =
    this.dialogData?.totalCount || this.unavailableItems.length;
  protected readonly iconName = IconName;

  public closeModal(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
